import React, { useState } from "react";
import { CardMedia, CardActionArea, Card, CardContent, Typography, Box } from "@mui/material";
import ArticleControls from './ArticleControls.js'
import { editArticleMetadata } from '../utils.js'
import DeleteArticleDialog from "./DeleteArticleDialog.js";
import Tags from "../Tags.js";
import { useNavigate } from "react-router-dom";

export default function ArticleCard(props = {}) {
  const navigate = useNavigate()
  const {
    index,
    article,
    maxWidth = '100%',
    minHeight = undefined,
    editable,
    published,
    sx = {},
    visibility
  } = props

  const [hovering, setHovering] = useState(false)
  const [deleteArticleDialogOpen, setDeleteArticleDialogOpen] = useState(false)

  const viewArticle = () => {
    if (article.newsWebUrl) {
      window.open(article.newsWebUrl, "_blank", "noopener,noreferrer");
    } else {
      if (article?.guid) {
        navigate(article.guid)
      } else if (article?.webUrl) {
        window.open(article.webUrl, "_blank", "noopener,noreferrer")
      }
    }
  }

  return (<>
    <DeleteArticleDialog
      open={deleteArticleDialogOpen}
      article={article}
      onClose={() => setDeleteArticleDialogOpen(false)}
    />

    <Card
      sx={{
        display: 'flex',
        ...sx
      }}
      key={'article' + index}
      className="secondary-article-card"
      style={{
        maxWidth,
        minHeight
      }}>
      <CardActionArea
        component='div'
        sx={{ display: 'flex' }}
        onMouseOver={() => setHovering(true)}
        onMouseOut={() => setHovering(false)}
        onClick={() => viewArticle()}
      >
        <Box 
        className="image-overlay"
         />
        {/* <Box className=".gradient-overlay" /> */}
        <CardMedia component="div" sx={article.image ? { backgroundImage: `url(${article.image})` } : undefined} alt="Featured Article" className="featured-image" />
        <CardMedia component="div" sx={article.image ? { backgroundImage: `url(${article.image})` } : undefined} alt="Featured Article" className="featured-image-blurred" />

        <CardContent className="secondary-article-content" >
          <div>
            <Typography variant="body1" className="secondary-article-title">
              {article.title}
            </Typography>
            <Typography variant="caption">
              {article.author} - {article.date}
            </Typography>
          </div>
          <Tags
            tags={article?.tags || ""}
            onSelectTag={_ => setHovering()}
            clickable={published}
            sx={{ marginTop: '4px' }}
          />
        </CardContent>
        {editable && <ArticleControls
          isDraft={article?.isDraft}
          isPinned={article?.metadata?.isPinned}
          hovering={hovering}
          onClickEdit={() => editArticleMetadata(article, visibility)}
          onClickDelete={() => setDeleteArticleDialogOpen(true)}
          showAdd={false}
          article={article}
        />}
      </CardActionArea>

    </Card>
  </>)
}